/* =========================================================================
   WHALE WATERS LODGE — behaviour
   Vanilla, no dependencies. Each function maps to a Shopify section's
   inline <script>. See SHOPIFY-HANDOVER.md §5.
   ========================================================================= */
(function () {
  'use strict';

  // Theme settings are injected by snippets/theme-config.liquid as window.WW_CONFIG.
  // The literals below are the fallbacks, and remain the documented defaults.
  var CFG = window.WW_CONFIG || {};
  var NB_BBID = CFG.nbId || '25466';                       // NightsBridge property id
  // Modern engine. Verified 2026-09-01: returns 200, sends no X-Frame-Options
  // and no CSP frame-ancestors, so it embeds cross-origin. The legacy
  // nightsbridge.co.za/bridge/book?bbid= URL still works but 302s — don't use it.
  var NB_BASE = 'https://book.nightsbridge.com/' + NB_BBID;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     RATE MODEL — single source of truth for every price on the site.
     ⚠ 2026 figures read from the LIVE NightsBridge rate card on 2026-09-01:
       R6 350 covers 1–4 guests, then +R900 for each guest from 5 to 14
       (so 6 guests = R8 150, 14 guests = R15 350).
     The current website publishes "Minimum rate for 1 - 6 people … R8 150",
     which is the 6-guest point on this curve mislabelled as a minimum — it
     overstates the price by up to R1 800/night for parties of four or fewer.
     2027 is DERIVED from the same shape using the client's published
     R8 965 / +R990 six-guest figure. CONFIRM BOTH YEARS WITH THE OWNER,
     and confirm whether the curve is seasonal. See SHOPIFY-HANDOVER.md §7.
     ---------------------------------------------------------------------- */
  var RATES = CFG.rates || {
    '2026': { base: 6350, baseGuests: 4, extra: 900,  max: 14 },
    '2027': { base: 6985, baseGuests: 4, extra: 990,  max: 14 }
  };
  var YEAR_A = CFG.yearA || Object.keys(RATES)[0];
  window.WW_RATES = RATES;

  function rateFor(guests, year) {
    var r = RATES[year] || RATES[YEAR_A];
    return r.base + Math.max(0, guests - r.baseGuests) * r.extra;
  }
  function zar(n) {
    return 'R' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
  window.WW_rateFor = rateFor;
  window.WW_zar = zar;

  /* ----------------------------------------------------------------------
     1. Mobile drawer
     ---------------------------------------------------------------------- */
  function initDrawer() {
    var drawer = document.getElementById('drawer');
    if (!drawer) return;
    var toggles = document.querySelectorAll('[data-drawer-toggle]');
    var lastFocus = null;

    function setOpen(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('body-lock', open);
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        lastFocus = document.activeElement;
        var first = drawer.querySelector('a, button');
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        setOpen(drawer.getAttribute('data-open') !== 'true');
      });
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') setOpen(false);
    });
  }

  /* ----------------------------------------------------------------------
     2. Header state — transparent over hero, solid once scrolled
     ---------------------------------------------------------------------- */
  function initHeader() {
    var bar = document.querySelector('.topbar');
    if (!bar) return;

    // Shopify wraps the header section in a div of its own, and that wrapper is
    // what actually sticks — a sticky child of a header-height box cannot move.
    // So the positioning classes go on the wrapper where there is one, and on
    // .topbar itself in the plain-HTML build.
    var host = bar.parentElement;
    while (host && !(host.classList &&
                     host.classList.contains('shopify-section-group-header-group'))) {
      host = host.parentElement;
    }
    var onWrapper = !!host;
    if (!host) host = bar;

    // Publish the real header height so in-page links clear it. Re-measured on
    // resize because the announcement bar wraps to two lines on small screens.
    function measure() {
      document.documentElement.style.setProperty(
        '--header-h', Math.round(bar.getBoundingClientRect().height) + 'px');
    }

    var over = bar.classList.contains('topbar--over');
    if (over && onWrapper) host.classList.add('is-over');

    var trigger = document.querySelector('[data-header-trigger]');
    function threshold() {
      return trigger ? Math.max(80, trigger.offsetHeight - bar.offsetHeight) : 200;
    }
    function update() {
      if (!over) return;                       // solid header already sticks in CSS
      var solid = window.scrollY > threshold();
      bar.classList.toggle('topbar--solid', solid);
      if (onWrapper) {
        host.classList.toggle('is-solid', solid);
        host.classList.toggle('is-over', !solid);
      }
    }

    measure();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { measure(); update(); }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(bar);
  }

  /* ----------------------------------------------------------------------
     3. Scroll reveal
     ---------------------------------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = parseInt(entry.target.getAttribute('data-reveal-delay') || '0', 10);
        setTimeout(function () { entry.target.classList.add('is-in'); }, delay);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------------------------
     4. Booking bar — pre-fills the NightsBridge deep link
     NOTE: NightsBridge query-param names for arrival date / nights are not
     publicly documented. Confirm with NightsBridge support, then set
     NB_PARAMS below. Until then we hand off to the property's booking page
     with the dates carried in the hash so nothing is lost.
     ---------------------------------------------------------------------- */
  function initBookingBar() {
    document.querySelectorAll('[data-booking-form]').forEach(function (form) {
      var arrive = form.querySelector('[name="arrive"]');
      var depart = form.querySelector('[name="depart"]');
      var guests = form.querySelector('[name="guests"]');

      // Sensible min dates + auto-advance depart when arrive changes
      var today = new Date().toISOString().slice(0, 10);
      if (arrive) arrive.min = today;
      if (depart) depart.min = today;
      if (arrive && depart) {
        arrive.addEventListener('change', function () {
          depart.min = arrive.value;
          if (depart.value && depart.value <= arrive.value) {
            var d = new Date(arrive.value);
            d.setDate(d.getDate() + 2);           // weekend minimum is 2 nights
            depart.value = d.toISOString().slice(0, 10);
          }
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var url = NB_BASE;
        var frag = [];
        if (arrive && arrive.value) frag.push('arrive=' + arrive.value);
        if (depart && depart.value) frag.push('depart=' + depart.value);
        if (guests && guests.value) frag.push('guests=' + guests.value);
        if (frag.length) url += '#' + frag.join('&');

        var target = form.getAttribute('data-booking-target');
        if (target === 'inline') {
          var frame = document.getElementById('nb-frame');
          if (frame) {
            frame.src = url;
            frame.closest('.nbframe').scrollIntoView({
              behavior: reduced ? 'auto' : 'smooth', block: 'start'
            });
            return;
          }
        }
        window.open(url, '_blank', 'noopener');
      });
    });
  }

  /* ----------------------------------------------------------------------
     4b. Film band
     Nothing about the film loads until it is asked for: the <video> carries
     preload="none", and an external embed is not written into the page at all
     until someone presses play. A 4K film on a phone on mobile data is the
     thing to avoid here.
     ---------------------------------------------------------------------- */
  function initFilm() {
    document.querySelectorAll('[data-film]').forEach(function (band) {
      var frame = band.querySelector('.filmband__frame');
      var video = band.querySelector('video');
      var play = band.querySelector('[data-film-play]');
      var sound = band.querySelector('[data-film-sound]');

      if (play) {
        play.addEventListener('click', function () {
          band.classList.add('is-playing');
          // The class fades the overlay out, but a stalled transition would
          // leave it sitting over a playing film. Take it out of sight for
          // certain once the fade has had its time.
          setTimeout(function () { play.style.visibility = 'hidden'; }, 400);
          if (video) {
            video.setAttribute('preload', 'auto');
            video.controls = true;
            var p = video.play();
            if (p && p.catch) p.catch(function () { /* the controls are there */ });
            video.focus();
            return;
          }
          // External film — build the player only now.
          var host = play.getAttribute('data-film-host');
          var id = play.getAttribute('data-film-id');
          if (!host || !id) return;
          var src = host === 'vimeo'
            ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1'
            : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
          var frameEl = document.createElement('iframe');
          frameEl.src = src;
          frameEl.title = play.textContent.trim() || 'Video';
          frameEl.allow = 'autoplay; fullscreen; picture-in-picture';
          frameEl.setAttribute('allowfullscreen', '');
          frameEl.setAttribute('loading', 'lazy');
          frame.appendChild(frameEl);
        });
      }

      if (!video) return;

      if (band.getAttribute('data-film-mode') === 'ambient') {
        // Reduced motion, or a visitor who has asked their phone to save data:
        // no wallpaper. Hand back the controls instead. A two-and-a-half minute
        // film looping on a mobile connection is not a courtesy.
        var conn = navigator.connection || {};
        var thrifty = conn.saveData === true || /^(slow-2g|2g)$/.test(conn.effectiveType || '');
        if (reduced || thrifty) {
          video.autoplay = false;
          video.loop = false;
          video.controls = true;
          video.pause();
          if (sound) sound.hidden = true;
          return;
        }
        // Stop paying for bandwidth once it scrolls out of sight.
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
              else video.pause();
            });
          }, { threshold: 0.15 }).observe(video);
        }
        if (sound) {
          sound.addEventListener('click', function () {
            video.muted = !video.muted;
            if (!video.muted) video.volume = 1;
            sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
            var use = sound.querySelector('use');
            if (use) use.setAttribute('href', video.muted ? '#i-sound-off' : '#i-sound-on');
            video.controls = !video.muted;
          });
        }
      }
    });
  }

  /* ----------------------------------------------------------------------
     5. Lightbox gallery
     ---------------------------------------------------------------------- */
  function initLightbox() {
    var box = document.getElementById('lightbox');
    if (!box) return;
    var img = box.querySelector('[data-lb-img]');
    var cap = box.querySelector('[data-lb-cap]');
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-lb]'));
    if (!all.length) return;
    var triggers = all, index = 0, lastFocus = null;

    // Only step through the pictures the gallery filter is showing, so the
    // arrows never land on a room when the guest asked to see the kitchen.
    function visible() {
      return all.filter(function (t) { return !t.closest('[hidden]'); });
    }
    function show(i) {
      index = (i + triggers.length) % triggers.length;
      var t = triggers[index];
      img.src = t.getAttribute('data-lb-full') || t.querySelector('img').src;
      img.alt = t.getAttribute('data-lb-alt') || '';
      cap.textContent = (index + 1) + ' / ' + triggers.length +
        (t.getAttribute('data-lb-alt') ? '  ·  ' + t.getAttribute('data-lb-alt') : '');
    }
    function open(t) {
      lastFocus = document.activeElement;
      triggers = visible();
      show(Math.max(0, triggers.indexOf(t)));
      box.setAttribute('data-open', 'true');
      box.setAttribute('aria-hidden', 'false');
      document.body.classList.add('body-lock');
      box.querySelector('.lightbox__close').focus();
    }
    function close() {
      box.setAttribute('data-open', 'false');
      box.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('body-lock');
      if (lastFocus) lastFocus.focus();
    }

    all.forEach(function (t) {
      t.addEventListener('click', function () { open(t); });
    });
    box.querySelector('.lightbox__close').addEventListener('click', close);
    box.querySelector('.lightbox__nav--prev').addEventListener('click', function () { show(index - 1); });
    box.querySelector('.lightbox__nav--next').addEventListener('click', function () { show(index + 1); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) {
      if (box.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
  }

  /* ----------------------------------------------------------------------
     5b. Gallery filter — ALL | THE HOUSE | LIVING & DINING | KITCHEN | ...
     Without JavaScript the buttons stay hidden and every picture shows.
     ---------------------------------------------------------------------- */
  function initGalleryFilter() {
    document.querySelectorAll('[data-gallery]').forEach(function (root) {
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
      var figs = Array.prototype.slice.call(root.querySelectorAll('[data-cat]'));
      var grid = root.querySelector('.mosaic');
      var count = root.querySelector('[data-gallery-count]');
      if (!buttons.length || !figs.length) return;

      function apply(cat) {
        var shown = 0;
        figs.forEach(function (f) {
          var on = cat === 'all' || f.getAttribute('data-cat') === cat;
          if (on) { f.removeAttribute('hidden'); shown++; } else { f.setAttribute('hidden', ''); }
        });
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-filter') === cat ? 'true' : 'false');
        });
        if (grid) grid.classList.toggle('is-filtered', cat !== 'all');
        if (count) count.textContent = shown + (shown === 1 ? ' photograph' : ' photographs');
      }
      buttons.forEach(function (b) {
        b.addEventListener('click', function () { apply(b.getAttribute('data-filter')); });
      });
      apply('all');
    });
  }

  /* ----------------------------------------------------------------------
     6. FAQ accordion
     ---------------------------------------------------------------------- */
  function initFaq() {
    document.querySelectorAll('.faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq__item');
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ----------------------------------------------------------------------
     7. Live rate calculator (whole-house) — reads the RATE MODEL above.
     Also shows the per-head figure, which is the number that actually wins
     the group-organiser comparison against a Hermanus guesthouse.
     ---------------------------------------------------------------------- */
  function initRateCalc() {
    var calc = document.querySelector('[data-rate-calc]');
    if (!calc) return;
    var guestsIn = calc.querySelector('[name="calc-guests"]');
    var nightsIn = calc.querySelector('[name="calc-nights"]');
    var yearIn = calc.querySelector('[name="calc-year"]');
    var outNight = calc.querySelector('[data-out-night]');
    var outTotal = calc.querySelector('[data-out-total]');
    var outHead = calc.querySelector('[data-out-head]');
    var outNote = calc.querySelector('[data-out-note]');

    function update() {
      var r = RATES[yearIn ? yearIn.value : YEAR_A] || RATES[YEAR_A];
      var lo = CFG.minGuests || 1;
      var g = Math.max(lo, Math.min(r.max, parseInt(guestsIn.value, 10) || lo));
      var n = Math.max(1, Math.min(30, parseInt(nightsIn.value, 10) || 1));
      var perNight = rateFor(g, yearIn ? yearIn.value : YEAR_A);

      outNight.textContent = zar(perNight);
      outTotal.textContent = zar(perNight * n);
      if (outHead) outHead.textContent = zar(Math.round(perNight / g)) + ' a head';
      if (outNote) {
        outNote.textContent = g > r.baseGuests
          ? zar(r.base) + ' covers the first ' + r.baseGuests + ' guests, plus ' + zar(r.extra) +
            ' each for ' + (g - r.baseGuests) + ' more. Children aged five and under stay free.'
          : zar(r.base) + ' covers up to ' + r.baseGuests + ' guests. Children aged five and under stay free.';
      }
    }
    [guestsIn, nightsIn, yearIn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', update);
      el.addEventListener('change', update);
    });
    update();
  }

  /* ----------------------------------------------------------------------
     7b. Build the full sliding-scale table from the rate model.
     No competitor in Walker Bay publishes this. It is the strongest
     transparency signal available to a property at this price point.
     ---------------------------------------------------------------------- */
  function initRateTable() {
    document.querySelectorAll('[data-rate-table]').forEach(function (tbody) {
      var year = tbody.getAttribute('data-rate-table');
      var r = RATES[year] || RATES[YEAR_A];
      var html = '';
      // One row for the flat band (1–baseGuests), then one row per extra guest.
      for (var g = r.baseGuests; g <= r.max; g++) {
        var per = rateFor(g, year);
        var label = (g === r.baseGuests) ? '1 &ndash; ' + r.baseGuests + ' guests' : g + ' guests';
        if (g === r.max) label += ' &mdash; full house';
        html += '<tr' + (g === r.max ? ' data-full="true"' : '') + '>' +
                '<td>' + label + '</td>' +
                '<td class="rates__figure">' + zar(per) + '</td>' +
                '<td>' + zar(Math.round(per / g)) + '</td></tr>';
      }
      tbody.innerHTML = html;
    });
  }

  /* ----------------------------------------------------------------------
     8. Enquiry form — client-side validation only (no backend in this build)
     ---------------------------------------------------------------------- */
  function initEnquiry() {
    var form = document.querySelector('[data-enquiry]');
    if (!form) return;
    // In Shopify this is a real {% form 'contact' %} and must post normally.
    // We only add the inline validation the browser will not do on its own,
    // then get out of the way.
    var live = form.hasAttribute('data-enquiry-live');
    form.addEventListener('submit', function (e) {
      var firstBad = null;
      form.querySelectorAll('[required]').forEach(function (f) {
        var ok = f.checkValidity();
        f.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok && !firstBad) firstBad = f;
      });
      var status = form.querySelector('[data-enquiry-status]');
      if (firstBad) {
        e.preventDefault();
        firstBad.focus();
        if (status) {
          status.textContent = 'Please complete the highlighted fields.';
          status.style.color = '#B4451F';
        }
        return;
      }
      if (live) return;                       // let Shopify take it from here
      e.preventDefault();
      if (status) {
        status.style.color = '';
        status.textContent = 'Demo build — this form is not yet wired to a mailbox.';
      }
    });
  }

  /* ---------------------------------------------------------------------- */
  function init() {
    initDrawer(); initHeader(); initReveal(); initBookingBar();
    initFilm();
    initGalleryFilter(); initLightbox(); initFaq(); initRateCalc(); initRateTable(); initEnquiry();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
